<template lang="pug">
v-card.column-editor-card
  v-card-text.column-editor-body.custom-scroll-area
    v-form(v-model="valid", ref="form")
      // description
      v-row
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.NAME')}}
        v-col.pa-0
          v-text-field(
            v-model='localData.description'
            outlined
            dense
            :rules='descriptionRules'
            required='required'
            :disabled='disabledAll'
            hide-details='auto'
            :placeholder='$t("DOCUMENT_AGENT_PROPERTY.FILL_COLUMN_NAME")'
          )

      // flexfield_datatype
      v-row
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.TYPE')}}
        v-col.pa-0
          v-select(
            ref="typeSelect"
            v-if='isTypeEditable'
            :items='type_items'
            item-text='name'
            item-value='key'
            v-model='localData.type_key'
            outlined
            dense
            :rules='typeRules'
            required='required'
            :disabled='typeSelectDisabled'
            hide-details='auto'
            :menu-props="{ contentClass: 'type-select-menu' }"
          )
            template(v-slot:item="{ item, attrs, on }")
              v-list-item(v-bind="attrs" v-on="on" dense class="type-item")
                div.type-option
                  span.type-icon
                    img(:src="item.icon" alt="")
                  span.type-label {{ item.name }}
            template(v-slot:selection="{ item }")
              div.type-option
                span.type-icon
                  img(:src="item.icon" alt="")
                span.type-label {{ item.name }}
          v-text-field.datatype-readonly(
            v-else
            v-model='localData.flexfield_datatype'
            outlined
            dense
            :rules='typeRules'
            required='required'
            :disabled='true'
            :readonly='true'
            hide-details='auto'
          )
            template(v-slot:prepend-inner)
              img(
                v-if='readonlyTypeIcon'
                :src='readonlyTypeIcon'
                alt=''
                style='width:20px;height:20px;display:block;'
              )

      // model
      v-row(v-if="!isDocumentOutput")
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 400; font-size: 14px;') {{ isFileInputColumn ? $t('DOCUMENT_AGENT_PROPERTY.VISION_MODEL') : $t('DOCUMENT_AGENT_PROPERTY.MODEL') }}
        v-col.pa-0(cols='9')
          v-select(
            :key='modelSelectKey'
            :items='filteredModelListWithIcon'
            item-text='name'
            item-value='id'
            :value='localData.model'
            @change='onModelChange'
            outlined
            dense
            :rules='formRule.requireRules'
            required='required'
            persistent-hint
            :disabled='disabledAll'
            :loading='modelListLoading'
            hide-details='auto'
          )
            template(v-slot:selection="{ item }")
              .d-flex.align-center
                img.model-option-icon.mr-2(:src='item.icon' alt='')
                span(style='color:#444444; font-weight: 400; font-size: 14px;') {{ item.name }}

            template(v-slot:item="{ item, attrs, on }")
              v-list-item(v-bind='attrs' v-on='on')
                .d-flex.align-center
                  img.model-option-icon.mr-2(:src='item.icon' alt='')
                  span(style='color:#444444; font-weight: 400; font-size: 14px;') {{ item.name }}

          // 模型清單取不到時的提示。刻意不讓它退化成一個空下拉——空下拉會讓
          // 使用者以為「沒有模型可用」，而真相是「租戶的設定還沒建立」。
          div.model-list-error(v-if="modelListError") {{ modelListErrorMessage }}
          div.model-list-error(v-else-if="noVisionModelAvailable") {{ $t('DOCUMENT_AGENT_PROPERTY.NO_VISION_MODEL') }}

      // pdf_as_image
      v-row(v-if="isInputFileType")
        v-col.pa-0(cols='3').d-flex.justify-start.align-center(style="min-height: 40px;")
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.PDF_AS_IMAGE')}}
        v-col.pa-0(cols='9').d-flex.align-center(style="min-height: 40px;")
          v-checkbox.ma-0.pa-0.flex-grow-0(
            v-model='localData.pdf_as_image'
            :disabled='disabledAll'
            color="#14C6DE"
            dense
            hide-details
            :ripple="false"
          )
          span(
            :title='$t("DOCUMENT_AGENT_PROPERTY.PDF_AS_IMAGE_HINT")'
            style='color:#444444; font-weight: 400; font-size: 12px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; min-width: 0;'
          ) {{$t('DOCUMENT_AGENT_PROPERTY.PDF_AS_IMAGE_HINT')}}
      // reasoning_effort
      v-row(v-if="!isUserInputModel && !isPythonTool && !isQRCodeModel && ['Text','Number','Collection','SingleSelect'].includes(resolvedDatatype)")
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.REASONING_EFFORT')}}
        v-col.pa-0(cols='9')
          v-select(
            :items='reasoning_list'
            item-text='name'
            item-value='id'
            v-model='localData.reasoning_effort'
            outlined
            dense
            :rules='formRule.requireRules'
            required='required'
            persistent-hint
            :disabled='disabledAll'
            hide-details='auto'
          )

      // web_search_enabled
      v-row(v-if="!isUserInputModel && !isPythonTool && !isQRCodeModel && !isDocumentOutput && !isFileInputColumn")
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('AGENT.SEARCH_WEB')}}
        v-col.pa-0(cols='9').d-flex.align-center(style="min-height: 40px;")
          label.UX-switch.mr-2
            input(v-model='localData.web_search_enabled' type="checkbox" :disabled='disabledAll')
            div(class="UX-slider round")
          span(v-if='localData.web_search_enabled' style='color:#666; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.OPEN_LIB")}}
          span(v-else style='color:#666; font-weight: 400; font-size: 14px;') {{$t("GPT_KNOWLEDGE.CLOSE_LIB")}}

      // output template (document_output 類型時顯示，add / edit 模式均適用)
      v-row(v-if="showTemplateField")
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.TEMPLATE')}}
        v-col.pa-0(cols='9')
          div.template-field-wrapper
            div.template-inline-group
              v-text-field.template-file-field(
                :value='hasTemplate ? (templateOriginalFilename || "template.docx") : ""'
                outlined
                dense
                readonly
                hide-details='auto'
                :placeholder='$t("DOCUMENT_AGENT_PROPERTY.TEMPLATE_PLACEHOLDER_DOCX_ONLY")'
              )
                template(v-slot:append)
                  v-btn.template-delete-inside(
                    v-if='hasTemplate || templateUrl'
                    icon
                    small
                    :ripple='false'
                    :disabled='disabledAll || templateUploading'
                    @click.stop='onDeleteTemplateClick'
                  )
                    v-icon(size='18' color='#888') icon-remove

              v-btn.template-upload-btn(
                outlined
                small
                height='32'
                :ripple='false'
                :disabled='disabledAll || templateUploading'
                :loading='templateUploading'
                @click='$refs.templateFileInput.click()'
              )
                img.template-upload-icon(:src='uploadIcon' alt='')
                | {{ hasTemplate ? $t('DOCUMENT_AGENT_PROPERTY.TEMPLATE_REUPLOAD') : $t('DOCUMENT_AGENT_PROPERTY.TEMPLATE') }}

          input(
            ref='templateFileInput'
            type='file'
            accept='.docx'
            style='display:none'
            @change='onTemplateFileSelected'
          )

      // input + read_documents + user_prompt
      template(v-if="!isUserInputModel && !isDocumentOutput && !isFileInputColumn")
        // input
        v-row
          v-col.pa-0(cols='3').d-flex.justify-start.align-start
            div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.INPUT')}}
          v-col.pa-0(cols='9')
            v-select(
              :items='userInputList'
              item-text='name'
              item-value='id'
              multiple
              v-model='localData.input'
              outlined
              dense
              :disabled='disabledAll'
              hide-details='auto'
              :placeholder='$t("DOCUMENT_AGENT_PROPERTY.CHOOSE_INPUT_COLUMN")'
            )
              template(v-slot:item="{ item, attrs, on }")
                v-list-item(v-bind="attrs" v-on="on" dense style="height: 20px;" class="knowledge-item")
                  v-list-item-action.ma-0.mr-2
                    v-checkbox.ma-0(:input-value="attrs.inputValue" color="#14C6DE" dense)
                  v-list-item-content.pa-0
                    v-list-item-title.knowledge-item-title
                      span.knowledge-item-name(:title="item.name") {{ item.name }}
                      span.input-var-hint(v-if="isPythonTool && item.name" :title="slugifyToVariable(item.name)") {{ slugifyToVariable(item.name) }}

        // read_documents
        v-row(v-if="!isPythonTool && !isQRCodeModel")
          v-col.pa-0(cols='3').d-flex.justify-start.align-start
            div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.READ_DOCUMENTS')}}
          v-col.pa-0(cols='9')
            v-autocomplete(
              ref="readDocsAC"
              :items='readDocumentsList'
              item-text='filename'
              item-value='id'
              multiple
              v-model='localData.read_documents'
              outlined
              dense
              :disabled='disabledAll'
              hide-details='auto'
              :placeholder='$t("DOCUMENT_AGENT_PROPERTY.CHOOSE_READ_DOCUMENTS")'
              :menu-props="{ closeOnClick:false }"
              no-filter
              :search-input.sync="readDocumentsSearch"
              :loading="readDocumentsLoading"
              @update:search-input="onReadDocumentsSearch"
              @blur="onReadDocumentsBlur"
              @focus="onReadDocumentsFocus"
            )
              template(v-slot:item="{ item, attrs, on }")
                v-list-item(v-bind="attrs" v-on="on" dense style="height: 20px;" class="knowledge-item")
                  v-list-item-action.ma-0.mr-2
                    v-checkbox.ma-0(:input-value="attrs.inputValue" color="#14C6DE" dense)
                  v-list-item-content.pa-0
                    v-list-item-title(style='color:#444444; font-weight: 400; font-size: 14px;')
                      | {{ readDocFileName(item) }}
              template(v-slot:selection="{ item }")
                v-chip(close small class="ma-1" @click:close="removeReadDocument(getReadDocId(item))")
                  | {{ readDocChipText(item) }}
              template(v-slot:append-item)
                div(v-intersect="onReadDocumentsIntersect" style="height: 1px;")
                v-list-item(v-if="readDocumentsLoading")
                  v-list-item-content
                    v-progress-circular(indeterminate size="18")
                v-list-item(v-else-if="!readDocumentsHasMore && (readDocumentsList || []).length > 0")
                  v-list-item-content
                    v-list-item-title(style="font-size:12px;color:#999;")
                      | 已載入全部

        // user_prompt
        v-row(v-if="!isPythonTool && !isQRCodeModel")
          v-col.pa-0(cols='12').d-flex.justify-start.align-start
            div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.USER_PROMPT')}}
          v-col.pa-0(cols='12').d-flex.justify-start.align-start
            v-textarea.user-prompt-field(
              v-model='localData.user_prompt'
              outlined
              dense
              auto-grow
              rows="3"
              :rules='userPromptRules'
              :required='!isUserInputModel'
              persistent-hint
              :disabled='disabledAll || addBtn_loading'
              hide-details='auto'
              :placeholder='$t("DOCUMENT_AGENT_PROPERTY.FILL_PROMPT")'
            )
          v-col.pa-0(cols='12' v-if='localData.web_search_enabled')
            div(style='color:#888888; font-weight: 400; font-size: 12px; margin-top: 4px;') {{$t('DOCUMENT_AGENT_PROPERTY.WEB_SEARCH_HINT')}}

        // python code editor
        v-row(v-if="isPythonTool")
          v-col.pa-0(cols='12').d-flex.justify-start.align-start
            div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.PYTHON_CODE')}}
          v-col.pa-0(cols='12')
            codemirror.python-editor(
              ref="pythonEditor"
              v-model='localData.tool_config'
              :options='cmOptions'
              @ready='onPythonEditorReady'
            )
          v-col.pa-0(cols='12').d-flex.justify-space-between.align-center.pt-1
            div.python-code-hint {{$t('DOCUMENT_AGENT_PROPERTY.PYTHON_CODE_HINT')}}
            div.python-char-counter(:class="{ 'python-char-counter--over': pythonCharCount > 5000 }")
              | {{ $t('DOCUMENT_AGENT_PROPERTY.PYTHON_CHAR_COUNT', { count: pythonCharCount.toLocaleString() }) }}
          v-col.pa-0(cols='12' v-if="pythonValidationErrors.length > 0")
            div.python-validation-errors
              div.python-validation-error(
                v-for="(msg, idx) in pythonValidationErrors"
                :key="idx"
              ) {{ msg }}

      // collection_properties
      v-row(v-if="resolvedDatatype === 'Collection'")
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.COLLECTION_PROPERTIES')}}
        v-col.pa-0(cols='9')
          div.d-flex.flex-column
            div.d-flex.align-center.mb-2(
              v-for="(item, index) in localData.collection_properties_description"
              :key="`colopt_${index}`"
            )
              v-text-field.collection-opt(
                v-model='localData.collection_properties_description[index]'
                outlined
                dense
                :disabled='disabledAll || addBtn_loading'
                hide-details='auto'
                :rules='formRule.requireRules'
                :error-messages='collectionDescErrors[index]'
                :placeholder='$t("RULE.RULE_R")'
                style="flex: 1 1 auto;"
              )
                template(v-slot:append)
                  v-btn(icon small :ripple="false" :disabled='disabledAll || addBtn_loading' @click.stop="removeCollectionOption(index)")
                    v-icon(size="18" color="#888") icon-remove
            v-btn(icon small depressed :ripple="false" :disabled='disabledAll || addBtn_loading' @click.stop="addCollectionOption" style="width:36px;height:28px;min-width:28px;border:1px solid rgba(0,0,0,.48);border-radius:6px;background:#fff;")
              v-icon(size="18" color="#666") mdi-plus

      // SingleSelect
      v-row(v-if="resolvedDatatype === 'SingleSelect'")
        v-col.pa-0(cols='3').d-flex.justify-start.align-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('DOCUMENT_AGENT_PROPERTY.OPTIONS')}}
        v-col.pa-0(cols='9')
          div
            v-text-field.singleselect-opt(
              v-for="(opt, idx) in localData.flexfield_datadetail"
              :key="opt._uid || idx"
              v-model="localData.flexfield_datadetail[idx].label"
              outlined
              dense
              hide-details='auto'
              :disabled='disabledAll || addBtn_loading'
              :placeholder='$t("RULE.RULE_R")'
              @blur="onSingleSelectOptionBlur(idx)"
              :error="shouldShowLabelError(opt)"
              :error-messages="getLabelErrorMessages(opt)"
            )
              template(v-slot:prepend-inner)
                v-menu(v-model="colorMenu.idx === idx" @input="val => { colorMenu.idx = val ? idx : null }" offset-y transition="scale-transition" :close-on-content-click="true")
                  template(v-slot:activator="{ on, attrs }")
                    div(v-bind="attrs" v-on="on" style="width:16px;height:16px;border-radius:3px;cursor:pointer;" :title="opt.color || '#CCCCCC'" :style="{ backgroundColor: opt.color || '#CCCCCC' }")
                  v-card(style="border-radius:6px;width:fit-content;")
                    v-card-text(style="padding:10px;")
                      div(style="display:grid;grid-template-columns:repeat(3,16px);gap:10px;")
                        div(v-for="c in COLOR_OPTIONS" :key="c" :title="c" :style="{ width:'16px',height:'16px',borderRadius:'3px',cursor:'pointer',backgroundColor:c }" @click="pickColor(c, idx)")
              template(v-slot:append)
                v-btn(icon small :ripple="false" :disabled='disabledAll || addBtn_loading' @click.stop="removeSingleSelectOption(idx)")
                  v-icon(size="18" color="#888") icon-remove
            v-btn(icon small depressed :ripple="false" :disabled='disabledAll || addBtn_loading' @click.stop="addSingleSelectOption" style="width:36px;height:28px;min-width:28px;border:1px solid rgba(0,0,0,.48);border-radius:6px;background:#fff;")
              v-icon(size="18" color="#666") mdi-plus

  // 離開 Python 確認 dialog
  v-dialog(v-model='leavePythonDialogOpen' max-width='480' :retain-focus='false')
    leave-python-confirm-dialog(
      @cancel='onCancelLeavePython'
      @confirm='onConfirmLeavePython'
    )

  // 刪除確認 dialog
  v-dialog(v-model='deleteConfirmOpen' max-width='480' :retain-focus='false')
    delete-template-confirm-dialog(
      @cancel='deleteConfirmOpen = false'
      @confirm='onDeleteTemplateConfirmed'
    )

  // ===== Footer =====
  div.d-flex.align-center.justify-space-between.column-editor-footer(style="background-color:#f4f4f4; height:60px;")
    v-btn.ml-4(:ripple="false" @click="onCancel" width="100" height="40" color="cancel" depressed outlined style='font-weight: 700;')
      | {{$t('GENERAL.CANCEL')}}
    div.d-flex.align-center.mr-4
      v-btn.mr-3(:ripple="false" @click="onConfirm(false)" width="100" height="40" color="#14C6DE" depressed dark :disabled="submitDisabled")
        v-progress-circular(v-if='isConfirmLoading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.SAVE')}}
      v-btn(v-if="isEditMode" :ripple="false" @click="onConfirm(true)" width="120" height="40" color="#14C6DE" depressed dark :disabled="submitRunDisabled")
        v-progress-circular(v-if='isConfirmLoading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('GENERAL.SAVEANDRUN')}}
</template>

<script>
import Vue from "vue";
import i18n from "/common/plugins/vue-i18n.js";
import GPTModelParameterList from "@/array/the_gpt_modelParameterList";
import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices";
// 模型清單改由租戶的模型偏好設定供給（不再前端硬編）。
// 注意：@/array/the_gpt_modelList 仍被 AI Bot 的元件使用，不可刪除該檔案，
// 這裡只是不再 import 它。
import workAgentModelService from "@/services/workAgentModelService";
import leavePythonConfirmDialog from './leavePythonConfirmDialog';
import deleteTemplateConfirmDialog from './deleteTemplateConfirmDialog';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/mode/python/python';

export default Vue.extend({
  name: "ColumnPropertyDialog",
  props: {
    mode: { type: String, default: "edit" },
    value: { type: Object, required: true },
    insertIndex: { type: Number, default: 0 },
    originalData: { type: Object, default: () => ({}) },
    addBtn_loading: { type: Boolean, default: false },
    disabledAll: { type: Boolean, default: false },
    canRunAgent: { type: Boolean, default: true },
    userInputList: { type: Array, required: true },
    readDocumentsList: { type: Array, default: () => [] },
    readDocumentsLoading: { type: Boolean, default: false },
    readDocumentsHasMore: { type: Boolean, default: false },
    isRootTable: { type: Boolean, default: true },
    oneDriveCount: { type: Number, default: 0 },
    existingColumns: { type: Array, default: () => [] },
    agentId: { type: String, default: "" },
    collectionChildColumns: { type: Array, default: () => [] },
  },
  components: {
    leavePythonConfirmDialog,
    deleteTemplateConfirmDialog,
    codemirror,
  },
  data() {
    return {
      valid: true,
      localData: {
        description: "",
        type_key: "text",
        // 預設模型由租戶清單的 is_default 決定，在 created() 內填入。
        model: "",
        reasoning_effort: "",
        input: [],
        read_documents: [],
        web_search_enabled: false,
        user_prompt: "",
        collection_properties: [],
        collection_properties_description: [],
        flexfield_datadetail: [],
        pdf_as_image: false,
      },
      model_list: [],
      // 模型清單取得失敗的原因（null = 正常）。值為 workAgentModelService 的
      // LOAD_ERROR_* 常數，用來決定顯示哪一種設定錯誤提示。
      modelListError: null,
      modelListLoading: false,
      reasoning_list: [{ name: "None", id: "none" }, ...GPTModelParameterList["reasoning_effort"]],
      formRule: {
        nameRules: [
          (v) => !!v || i18n.t("RULE.RULE_R"),
          (v) => /^.{0,100}$/.test(v) || i18n.t("RULE.RULE_100"),
          (v) => /^[\p{L}\p{N}\p{Zs}\p{P}\p{S}]+$/u.test(String(v || "")) || i18n.t("RULE.NO_SPECIAL_SYMBOL"), // 放寬全形符號文字數字
        ],
        requireRules: [(v) => !!String(v || "").trim() || i18n.t("RULE.RULE_R")],
      },
      COLOR_OPTIONS: [
        "#65B6FF","#BC6EFE","#FF9900","#FF4D4D","#00ABC8","#B19700",
        "#3B97EA","#8C3AD0","#D5840A","#D01111","#0A9DB5","#8B7600",
        "#3B64EA","#C83AD0","#A86705","#B40000","#068499","#716000"
      ],
      colorMenu: { idx: null },
      readDocumentsSearch: "",
      readDocumentsTimer: null,
      readDocumentsCache: {},
      readDocsNeedReload: false,
      singleSelectShowErrors: false,
      deletedSingleSelectLabels: [],
      templateUploading: false,
      deleteConfirmOpen: false,
      leavePythonDialogOpen: false,
      pendingModelSwitch: null,
      modelSelectKey: 0,
      pendingUploadFile: null,
      pendingDeleteColumnName: null,
      pythonValidationErrors: [],
      pythonValidating: false,
      userInputIcon: require('@/assets/images/user_input_icon.svg'),
      chatGptIcon: require('@/assets/images/chat_gpt_icon.svg'),
      pythonIcon: require('@/assets/images/python_icon.svg'),
      qrcodeIcon: require('@/assets/images/qr code.svg'),
      uploadIcon: require('@/assets/images/upload_icon.svg'),
      typeCollectionIcon: require("@/assets/images/type_collection_icon.svg"),
      typeDateIcon: require("@/assets/images/type_date_icon.svg"),
      typeOneDriveIcon: require("@/assets/images/type_onedrive_icon.svg"),
      typeFileIcon: require("@/assets/images/type_file_icon.svg"),
      typeNumberIcon: require("@/assets/images/type_number_icon.svg"),
      typeSingleSelectIcon: require("@/assets/images/type_single_select_icon.svg"),
      typeTextIcon: require("@/assets/images/type_text_icon.svg"),
      typeDocumentOutputIcon: require("@/assets/images/type_document_output_icon.svg"),
    };
  },
  created() {
    this.loadModelList();
  },
  mounted() {
    if (this.isPythonTool) {
      this.refreshPythonEditor();
      if (this.mode === 'edit') {
        this.$nextTick(() => this.runPythonValidation());
      }
    }
  },
  computed: {
    // File 欄位（FileUpload / OneDrive）；model 在此代表 IDP 的 vision 模型
    isFileInputColumn() {
      return String(this.resolvedDatatype || "") === "File" && !this.isDocumentOutput;
    },
    noVisionModelAvailable() {
      return this.isFileInputColumn && !this.modelListLoading && this.filteredModelList.length === 0;
    },
    collectionDescErrors() {
      const list = (this.localData.collection_properties_description || []).map(
        v => String(v || "").trim()
      );
      const props = this.localData.collection_properties || [];
      const counts = {};
      list.forEach(v => { if (v) counts[v] = (counts[v] || 0) + 1; });
      return list.map((v, i) => {
        if (!v) return "";
        if (counts[v] > 1) return this.$t("DOCUMENT_AGENT_PROPERTY.COLLECTION_NAME_DUPLICATE");
        const linkedId = String(props[i] || "").trim();
        const hasChildConflict = (this.collectionChildColumns || []).some(c => {
          const d = String(c?.description || "").trim();
          const colId = String(c?.name || "").trim();
          return d === v && colId !== linkedId;
        });
        if (hasChildConflict) return this.$t("DOCUMENT_AGENT_PROPERTY.COLLECTION_NAME_DUPLICATE");
        return "";
      });
    },
    collectionHasDuplicates() {
      return this.collectionDescErrors.some(e => !!e);
    },
    filteredModelListWithIcon() {
      return (this.filteredModelList || []).map(item => ({
        ...item,
        icon: this.getModelIcon(item),
      }));
    },
    modelListErrorMessage() {
      if (this.modelListError === workAgentModelService.LOAD_ERROR_NOT_CONFIGURED) {
        return this.$t("DOCUMENT_AGENT_PROPERTY.MODEL_LIST_NOT_CONFIGURED");
      }
      if (this.modelListError) {
        return this.$t("DOCUMENT_AGENT_PROPERTY.MODEL_LIST_LOAD_FAILED");
      }
      return "";
    },
    showTemplateField() {
      return this.localData?.type_key === "document_output";
    },
    templateUrl() {
      const detail = this.localData?.flexfield_datadetail;
      if (!detail || typeof detail !== "object" || Array.isArray(detail)) return null;
      return detail.template_url || null;
    },
    templateOriginalFilename() {
      if (this.pendingUploadFile) return this.pendingUploadFile.name;
      const detail = this.localData?.flexfield_datadetail;
      if (!detail || typeof detail !== "object" || Array.isArray(detail)) return null;
      return detail.template_original_filename || null;
    },
    hasTemplate() {
      return !!this.pendingUploadFile || !!this.templateUrl;
    },
    cmOptions() {
      return {
        mode: 'python',
        lineNumbers: true,
        lineWrapping: false,
        readOnly: (this.disabledAll || this.addBtn_loading) ? 'nocursor' : false,
        tabSize: 4,
        indentWithTabs: false,
      };
    },
    pythonCharCount() {
      return String(this.localData.tool_config || '').length;
    },
    isUserInputModel() {
      return String(this.localData?.model || "") === "userinput";
    },
    isPythonTool() {
      return String(this.localData?.model || "") === "python";
    },
    isQRCodeModel() {
      return String(this.localData?.model || "") === "qrcode";
    },
    isDocumentOutput() {
      return this.localData?.type_key === "document_output";
    },
    isInputFileType() {
      return ["file_upload", "onedrive"].includes(this.localData?.type_key);
    },
    filteredModelList() {
      let list = this.model_list || [];
      if (this.isFileInputColumn) {
        return list.filter(m => !workAgentModelService.isReservedModelId(m.id) && m.supports_vision === true);
      }
      if (this.localData?.type_key === "document_output") {
        list = list.filter(m => m.id !== "userinput");
      }
      if (!["Text", "Number"].includes(this.resolvedDatatype)) {
        list = list.filter(m => m.id !== "python");
      }
      if (this.resolvedDatatype !== "Text") {                 
        list = list.filter(m => m.id !== "qrcode");           
      }                                                      
      return list;
    },
    isEditMode() {
      return this.mode === "edit";
    },
    isTypeEditable() {
      if (!this.isEditMode) return true;
      const dt = String(this.localData?.flexfield_datatype || "").trim().toLowerCase();
      return dt === "file";
    },
    resolvedTypeObj() {
      return (this.type_items || []).find(x => x.key === this.localData.type_key) || null;
    },
    resolvedDatatype() {
      if (this.isTypeEditable) {
        return this.resolvedTypeObj?.datatype || "Text";
      }
      return String(this.localData?.flexfield_datatype || "").trim();
    },
    resolvedDatadetail() {
      if (this.isTypeEditable) {
        return this.resolvedTypeObj?.datadetail ?? null;
      }
      return this.localData?.flexfield_datadetail ?? null;
    },
    userPromptRules() {
      if (this.isUserInputModel) return [];
      return [(v) => !!String(v || "").trim() || i18n.t("RULE.RULE_R")];
    },
    type_items() {
      const all = [
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.FILE_UPLOAD"), key: "file_upload", datatype: "File", datadetail: { type: "FileUpload" }, icon: this.typeFileIcon },
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.ONEDRIVE_FILE"), key: "onedrive", datatype: "File", datadetail: { type: "OneDrive" }, icon: this.typeOneDriveIcon },
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.DOCUMENT_OUTPUT"), key: "document_output", datatype: "File", datadetail: { type: "DocumentOutput" }, icon: this.typeDocumentOutputIcon },
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.TEXT"), key: "text", datatype: "Text", datadetail: null, icon: this.typeTextIcon },
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.NUMBER"), key: "number", datatype: "Number", datadetail: null, icon: this.typeNumberIcon },
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.COLLECTION"), key: "collection", datatype: "Collection", datadetail: null, icon: this.typeCollectionIcon },
        { name: this.$t("DOCUMENT_AGENT_PROPERTY.SINGLE_SELECT"), key: "singleselect", datatype: "SingleSelect", datadetail: null, icon: this.typeSingleSelectIcon },
      ];
      if (this.mode !== "edit") return all;
      const dt = String(this.localData?.flexfield_datatype || "").trim().toLowerCase();
      if (dt === "file") return all.filter(x => x.datatype === "File");
      return all.filter(x => x.datatype !== "File");
    },
    labelCountMap() {
      const list = Array.isArray(this.localData?.flexfield_datadetail) ? this.localData.flexfield_datadetail : [];
      const map = Object.create(null);
      for (const o of list) {
        const key = String(o?.label ?? "").trim();
        if (!key) continue;
        map[key] = (map[key] || 0) + 1;
      }
      return map;
    },
    hasInvalidLabels() {
      if (this.resolvedDatatype !== "SingleSelect") return false;
      const list = Array.isArray(this.localData?.flexfield_datadetail) ? this.localData.flexfield_datadetail : [];
      const hasEmpty = list.some(o => !String(o?.label ?? "").trim());
      const hasDuplicate = Object.values(this.labelCountMap).some(n => n > 1);
      return hasEmpty || hasDuplicate;
    },
    isConfirmLoading() {
      return this.addBtn_loading || this.pythonValidating;
    },
    submitDisabled() {
      return this.disabledAll || this.pythonValidating;
    },
    submitRunDisabled() {
      return this.submitDisabled || !this.canRunAgent;
    },
    typeSelectDisabled() {
      return this.disabledAll && !this.isTypeEditable;
    },
    typeRules() {
      return [
        (v) => !!v || i18n.t("RULE.RULE_R"),
        (v) => {
          const key = String(v || "");
          if (key === "document_output" && !this.isRootTable) {
            return this.$t("DOCUMENT_AGENT_PROPERTY.ERROR_DOCUMENT_OUTPUT_IN_COLLECTION");
          }
          if (key !== "onedrive") return true;
          if (!this.isRootTable) {
            return this.$t("DOCUMENT_AGENT_PROPERTY.ERROR_ONEDRIVE_IN_COLLECTION");
          }
          const rawDetail = this.originalData?.flexfield_datadetail;
          const originalDetailType = rawDetail && typeof rawDetail === "object" ? rawDetail.type : rawDetail;
          const isEditingCurrentOneDrive =
            this.mode === "edit" &&
            String(this.originalData?.flexfield_datatype || "").toLowerCase() === "file" &&
            originalDetailType === "OneDrive";
          const effectiveOneDriveCount = Number(this.oneDriveCount || 0) - (isEditingCurrentOneDrive ? 1 : 0);
          if (effectiveOneDriveCount >= 1) {
            return this.$t("DOCUMENT_AGENT_PROPERTY.ERROR_ONEDRIVE_ONLY_ONE");
          }
          return true;
        },
      ];
    },
    readonlyTypeIcon() {
      const dt = String(this.localData?.flexfield_datatype || "").trim().toLowerCase();
      if (dt === "number") return this.typeNumberIcon;
      if (dt === "collection") return this.typeCollectionIcon;
      if (dt === "singleselect") return this.typeSingleSelectIcon;
      return this.typeTextIcon;
    },
    descriptionRules() {
      return [
        ...this.formRule.nameRules,                                                                           // 不可為空
        (v) => {
          const current = String(v || "").trim();
          if (!current) return true;
          const selfColumn = String(this.localData?.flexfield_column || this.localData?.field || "").trim();  // 當前欄位
          const duplicated = (this.existingColumns || []).some(col => {                                       // 檢查同一層中，是否有同名且也是 Collection 的欄位
            const colName = String(col?.description || "").trim();
            const colField = String(col?.flexfield_column || col?.field || "").trim();
            if (selfColumn && colField === selfColumn) return false;
            return colName === current;
          });
          if (!duplicated) return true;
          return this.$t("DOCUMENT_AGENT_PROPERTY.ERROR_DUPLICATE_COLUMN_NAME");
        },
      ];
    },
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(v) {
        const cloned = JSON.parse(JSON.stringify(v || {}));
        this.localData = { ...this.localData, ...cloned };
        this.ensureSingleSelectUids(this.localData);
        if (this.mode === "edit") {
          const dt = String(this.localData?.flexfield_datatype || "").trim().toLowerCase();
          if (dt === "file") {
            const raw = this.localData?.flexfield_datadetail;
            const detail = (typeof raw === 'object' && raw !== null) ? raw.type : raw;
            if (detail === "OneDrive") this.localData.type_key = "onedrive";
            else if (detail === "DocumentOutput") this.localData.type_key = "document_output";
            else this.localData.type_key = "file_upload";
            this.localData.pdf_as_image =
              !!(raw && typeof raw === "object" && !Array.isArray(raw) && raw.pdf_as_image);
          }else if (dt === "singleselect") {
            this.localData.type_key = "singleselect";
          } else if (dt === "collection") {
            this.localData.type_key = "collection";
          } else if (dt === "number") {
            this.localData.type_key = "number";
          } else {
            this.localData.type_key = "text";
          }
        }
        this.ensureCollectionOption();
        if (String(this.localData?.model || "") === "python") {
          const tc = this.localData?.tool_config;
          const tcScript = (tc && typeof tc === "object") ? (tc.script || "") : "";
          if (tcScript) {
            this.localData.tool_config = tcScript;
          }
          this.$nextTick(() => {
            requestAnimationFrame(() => {
              this.refreshPythonEditor();
            });
          });
        }
      },
    },
    "localData.model": {
      immediate: true,
      handler(val) {
        if (String(val) === "userinput") {
          this.localData.reasoning_effort = "";
          this.localData.input = [];
          this.localData.read_documents = [];
          this.localData.web_search_enabled = false;
          this.localData.user_prompt = "";
          this.localData.collection_properties_description = [];
          this.localData.collection_properties = [];
          this.localData.flexfield_datadetail = [];
          this.$refs.form?.resetValidation?.();
        } else if (String(val) === "python") {
          this.localData.reasoning_effort = "";
          this.localData.read_documents = [];
          this.localData.web_search_enabled = false;
          this.$refs.form?.resetValidation?.();
        } else if (String(val) === "qrcode") {               
          this.localData.reasoning_effort = "";
          this.localData.read_documents = [];
          this.localData.web_search_enabled = false;
          this.localData.user_prompt = "";
          this.$refs.form?.resetValidation?.();
        } else {
          if (!String(this.localData.reasoning_effort || "").trim()) {
            this.localData.reasoning_effort = "minimal";
          }
          this.ensureCollectionOption();
        }
      },
    },
    "localData.type_key"(val) {
      if (val === "document_output") {
        this.localData.model = "";
      }
      if (val === "file_upload" || val === "onedrive") {
        this.ensureFileVisionModel();
      }
      if (!["Text", "Number"].includes(this.resolvedDatatype) && String(this.localData?.model || "") === "python") {
        // Python Tool 不適用於此資料型別，退回租戶清單的預設模型（原本硬編 gpt52）
        this.localData.model = workAgentModelService.pickDefaultModelId(this.model_list);
        this.localData.user_prompt = "";
      }
      if (this.resolvedDatatype !== "Text" && String(this.localData?.model || "") === "qrcode") {   // ← 新增
        this.localData.model = workAgentModelService.pickDefaultModelId(this.model_list);
      }
      if (this.resolvedDatatype === "Collection") {
        this.ensureCollectionOption();
      } else {
        this.localData.collection_properties_description = [];
        this.localData.collection_properties = [];
      }
      if (this.resolvedDatatype !== "SingleSelect") this.localData.flexfield_datadetail = [];
      this.$nextTick(() => {
        this.$refs.typeSelect?.validate?.();
      });
      if (!["file_upload", "onedrive"].includes(val)) this.localData.pdf_as_image = false;
    },
    readDocumentsList: {
      immediate: true,
      handler(list) {
        (list || []).forEach(it => {
          this.$set(this.readDocumentsCache, it.id, it);
        });
      },
    },
    resolvedDatatype(newVal) {
      if (String(newVal) === "Collection") {
        this.ensureCollectionOption();
      }
      if (this.disabledAll) return;
      if (String(newVal) === "File" && this.localData?.type_key !== "document_output") {
        this.ensureFileVisionModel();
      }
    },
    isPythonTool(val) {
      if (val) {
        this.refreshPythonEditor();
      }
    },
    "localData.tool_config"() {
      if (this.isPythonTool && this.pythonValidationErrors.length > 0) {
        this.pythonValidationErrors = [];
      }
    },
  },
  methods: {
    slugifyToVariable(description) {
      if (!description) return '';
      let result = String(description);
      result = result.replace(/[^\p{L}\p{N}]/gu, '_');
      result = result.replace(/_+/g, '_');
      if (/^[0-9]/.test(result)) {
        result = '_' + result;
      }
      return result;
    },
    // File 欄位目前的 model 不是可選的 vision 模型時（保留值 / 空值），補上預設 vision 模型。
    // 只改畫面上的 localData，使用者不存檔就不會寫回，不動舊資料。
    ensureFileVisionModel() {
      if (!this.isFileInputColumn) return;
      const current = String(this.localData?.model || "").trim();
      if (current && !workAgentModelService.isReservedModelId(current)) return;
      this.localData.model = workAgentModelService.pickDefaultVisionModelId(this.model_list);
    },
    onPythonEditorReady(cm) {
      setTimeout(() => cm.refresh(), 300);
    },
    validateRequiredBeforeSubmit() {
      const descriptionOk = !!String(this.localData?.description || "").trim();
      const typeOk = !!String(this.resolvedDatatype || "").trim();
      const userPromptOk = this.isQRCodeModel || this.isUserInputModel || this.isDocumentOutput || this.isPythonTool || this.isFileInputColumn || !!String(this.localData?.user_prompt || "").trim();
      const collectionList = Array.isArray(this.localData?.collection_properties_description) ? this.localData.collection_properties_description : [];
      const collectionOk =
        this.resolvedDatatype !== "Collection" ||
        (collectionList.length > 0 && collectionList.every(v => !!String(v || "").trim()));
      const pythonCodeOk = !this.isPythonTool || this.pythonCharCount <= 5000;
      return descriptionOk && typeOk && userPromptOk && collectionOk && pythonCodeOk && !this.collectionHasDuplicates;
    },
    validateForm() {
      const uiValid = this.$refs.form?.validate?.();
      return Boolean(uiValid) && this.validateRequiredBeforeSubmit();
    },
    buildPayload() {
      const dt = this.resolvedDatatype;
      const clean = (v) => String(v || "").trim();
      // document_output: 保留 localData 中的 template_url / template_original_filename
      let fileDatadetail = this.resolvedDatadetail;
      const ld = this.localData?.flexfield_datadetail;
      const baseDetail = (ld && typeof ld === "object" && !Array.isArray(ld)) ? { ...ld } : {};
      if (dt === "File" && this.localData?.type_key === "document_output") {
        fileDatadetail = { type: "DocumentOutput", ...baseDetail };
      } else if (dt === "File" && this.isInputFileType) {
        // 保留既有的其他 key，type 以目前選的類型為準
        // 模板相關的 key 只屬於產出文件，這裡移除
        delete baseDetail.template_url;
        delete baseDetail.template_original_filename;
        fileDatadetail = {
          ...baseDetail,
          ...this.resolvedDatadetail,
          pdf_as_image: !!this.localData.pdf_as_image,
        };
      }
      const payload = {
        description: clean(this.localData.description),
        flexfield_datatype: dt,
        flexfield_datadetail:
          dt === "SingleSelect"
            ? (this.localData.flexfield_datadetail || []).map(x => ({
                color: x?.color || "#CCCCCC",
                label: clean(x?.label),
              }))
            : (dt === "File" ? fileDatadetail : null),
        model: this.isDocumentOutput ? "" : this.localData.model,
        tool: this.isPythonTool ? "python" : null,
        reasoning_effort: (this.isFileInputColumn || this.isQRCodeModel) ? "" : (this.localData.reasoning_effort || ""),
        input: Array.isArray(this.localData.input) ? this.localData.input : [],
        read_documents: Array.isArray(this.localData.read_documents) ? this.localData.read_documents : [],
        web_search_enabled: !!this.localData.web_search_enabled,
        user_prompt: (this.isPythonTool || this.isFileInputColumn || this.isQRCodeModel) ? "" : (this.localData.user_prompt || ""),
        tool_config: this.isPythonTool ? { script: this.localData.tool_config || "" } : undefined,
        collection_properties: dt === "Collection"
          ? (this.localData.collection_properties || [])
          : [],
        collection_properties_description:
          dt === "Collection"
            ? (this.localData.collection_properties_description || []).map(clean)
            : [],
      };
      if (this.mode === "edit") {
        payload.flexfield_column = this.localData.flexfield_column || this.localData.field;
        payload.name = this.localData.name;
      }
      return payload;
    },
    async onConfirm(runAfterUpdate) {
      if (this.disabledAll || this.addBtn_loading || this.pythonValidating) return;
      if (this.resolvedDatatype === "SingleSelect") {
        this.singleSelectShowErrors = true;
        if (this.hasInvalidLabels) return;
      } else {
        this.singleSelectShowErrors = false;
      }
      if (!this.validateForm()) {
        if (this.isPythonTool && this.pythonCharCount > 5000) {
          this.pythonValidationErrors = [
            this.$t('DOCUMENT_AGENT_PROPERTY.VALIDATION_OVER_LIMIT', { n: this.pythonCharCount.toLocaleString() })
          ];
        }
        return;
      }
      if (this.isPythonTool) {
        const passed = await this.runPythonValidation();
        if (!passed) return;
      }
      // edit 模式：column_name 已知，先上傳，template_url 帶入 save payload
      if (this.mode === "edit" && this.pendingUploadFile) {
        const uploadResult = await this.uploadPendingTemplate(this.localData.name);
        if (uploadResult) {
          if (!this.localData.flexfield_datadetail || typeof this.localData.flexfield_datadetail !== "object" || Array.isArray(this.localData.flexfield_datadetail)) {
            this.$set(this.localData, "flexfield_datadetail", { type: "DocumentOutput" });
          }
          this.$set(this.localData.flexfield_datadetail, "template_url", uploadResult.template_url);
          this.$set(this.localData.flexfield_datadetail, "template_original_filename", uploadResult.template_original_filename);
        }
      }
      // 若使用者在 Dialog 內刪除了模板，fire-and-forget 刪除 blob
      if (this.pendingDeleteColumnName && this.agentId) {
        UpGPTPortalDataServices.deleteOutputTemplate(
          this.agentId,
          this.pendingDeleteColumnName
        ).catch(() => {});
      }
      this.pendingDeleteColumnName = null;
      this.$emit("confirm", {
        mode: this.mode,
        insertIndex: this.insertIndex,
        payload: this.buildPayload(),
        runAfterUpdate: !!runAfterUpdate,
        deletedSingleSelectLabels: this.deletedSingleSelectLabels,
      });
    },
    onCancel() {
      this.cleanup();
      this.$emit("cancel");
    },
    onModelChange(newVal) {
      if (String(this.localData.model) === "python" && String(newVal) !== "python") {
        this.pendingModelSwitch = newVal;
        this.leavePythonDialogOpen = true;
        return;
      }
      this.localData.model = newVal;
    },
    onConfirmLeavePython() {
      this.localData.model = this.pendingModelSwitch;
      this.localData.user_prompt = "";
      this.pendingModelSwitch = null;
      this.leavePythonDialogOpen = false;
    },
    onCancelLeavePython() {
      this.pendingModelSwitch = null;
      this.leavePythonDialogOpen = false;
      this.modelSelectKey++;
    },
    resetValidationOnClose() {
      this.$refs.form?.resetValidation?.();
    },
    // #8438 模板上傳
    cleanup() {
      this.pendingUploadFile = null;
      this.pendingDeleteColumnName = null;
    },
    onTemplateFileSelected(event) {
      const file = event?.target?.files?.[0];
      if (!file) return;
      const ext = file.name.split(".").pop().toLowerCase();
      if (ext !== "docx") {
        alert(this.$t("DOCUMENT_AGENT_PROPERTY.TEMPLATE_FORMAT_ERROR"));
        event.target.value = "";
        return;
      }
      this.pendingUploadFile = file;
      this.pendingDeleteColumnName = null;
      event.target.value = "";
    },
    async uploadPendingTemplate(columnName) {
      if (!this.pendingUploadFile || !columnName || !this.agentId) return null;
      this.templateUploading = true;
      try {
        const formData = new FormData();
        formData.append("file", this.pendingUploadFile);
        formData.append("column_name", columnName);
        const res = await UpGPTPortalDataServices.uploadOutputTemplate(this.agentId, formData);
        this.pendingUploadFile = null;
        return res.data;
      } catch (e) {
        console.error("Template upload failed", e);
        return null;
      } finally {
        this.templateUploading = false;
      }
    },
    onDeleteTemplateClick() {
      this.deleteConfirmOpen = true;
    },
    onDeleteTemplateConfirmed() {
      this.pendingDeleteColumnName = this.localData.name;
      this.pendingUploadFile = null;
      this.$set(this.localData.flexfield_datadetail, "template_url", null);
      this.$set(this.localData.flexfield_datadetail, "template_original_filename", null);
      this.deleteConfirmOpen = false;
    },
    getPendingUploadFile() {
      return this.pendingUploadFile;
    },
    // Collection
    addCollectionOption() {
      if (this.disabledAll || this.addBtn_loading) return;
      if (!Array.isArray(this.localData.collection_properties_description)) {
        this.$set(this.localData, "collection_properties_description", []);
      }
      if (!Array.isArray(this.localData.collection_properties)) {
        this.$set(this.localData, "collection_properties", []);
      }
      this.localData.collection_properties_description.push("");
      this.localData.collection_properties.push("");
    },
    removeCollectionOption(idx) {
      if (this.disabledAll || this.addBtn_loading) return;
      this.localData.collection_properties_description.splice(idx, 1);
      if (Array.isArray(this.localData.collection_properties)) {
        this.localData.collection_properties.splice(idx, 1);
      }
    },
    // SingleSelect
    genOptUid() {
      return `uid_${Date.now()}_${Math.random().toString(16).slice(2)}`;
    },
    pickColor(color, idx) {
      const list = this.localData.flexfield_datadetail;
      if (!Array.isArray(list) || !list[idx]) return;
      this.$set(list[idx], "color", color);
      this.colorMenu.idx = null;
    },
    getNextSingleSelectColor() {
      const list = this.localData?.flexfield_datadetail;
      const used = new Set((Array.isArray(list) ? list : []).map(x => String(x?.color || "").toUpperCase()));
      const opts = (this.COLOR_OPTIONS || []).map(x => String(x).toUpperCase());
      const firstUnused = opts.find(c => c && !used.has(c));
      if (firstUnused) return firstUnused;
      if (!opts.length) return "#65B6FF";
      const idx =
        (Array.isArray(list) ? list.length : 0) >= 18
          ? opts.indexOf("#716000")
          : ((Array.isArray(list) ? list.length : 0) % opts.length);
      return opts[idx];
    },
    addSingleSelectOption() {
      if (this.disabledAll || this.addBtn_loading) return;
      if (!Array.isArray(this.localData.flexfield_datadetail)) {
        this.$set(this.localData, "flexfield_datadetail", []);
      }
      const color = this.getNextSingleSelectColor();
      this.localData.flexfield_datadetail.push({ _uid: this.genOptUid(),_labelBlurred: false, color, label: "" });  // 新增當下不顯示錯誤
    },
    removeSingleSelectOption(idx) {
      if (this.disabledAll || this.addBtn_loading) return;
      const list = this.localData?.flexfield_datadetail;
      if (!Array.isArray(list) || idx < 0 || idx >= list.length) return;
      const orig = String(list[idx]?._origLabel ?? "").trim();
      if (orig) this.deletedSingleSelectLabels.push(orig);
      if (this.colorMenu?.idx === idx) this.colorMenu.idx = null;
      else if (typeof this.colorMenu?.idx === "number" && this.colorMenu.idx > idx) this.colorMenu.idx -= 1;
      list.splice(idx, 1);
    },
    onSingleSelectOptionBlur(idx) {                       // 輸入框 blur 時觸發
      const list = this.localData?.flexfield_datadetail;
      if (!Array.isArray(list) || !list[idx]) return;
      this.$set(list[idx], "_labelBlurred", true);        // labelBlurred = true，已被使用者碰過
    },
    shouldShowLabelError(option) {                        // 是否顯示紅字/紅框
      if (!this.singleSelectShowErrors && !option?._labelBlurred) return false;           // 尚未 blur 過，不顯示
      return this.isEmptyLabel(option) || this.isDuplicateLabel(option);
    },
    isDuplicateLabel(option) {
      const key = String(option?.label ?? "").trim();
      return !!key && (this.labelCountMap[key] > 1);
    },
    isEmptyLabel(option) {
      return !String(option?.label ?? "").trim();
    },
    getLabelErrorMessages(option) {
      if (!this.shouldShowLabelError(option)) return [];
      if (this.isEmptyLabel(option)) {
        return [this.$t("RULE.RULE_R")];
      }
      if (this.isDuplicateLabel(option)) {
        const msg = this.$t("DOCUMENT_AGENT_PROPERTY.ERROR_DUPLICATE_OPTION");
        return [msg === "DOCUMENT_AGENT_PROPERTY.ERROR_DUPLICATE_OPTION" ? "選項名稱不可重複" : msg];
      }
    },
    ensureSingleSelectUids(obj) {
      if (!obj) return;
      const dt = String(obj.flexfield_datatype || "").toLowerCase();
      if (dt !== "singleselect") return;
      if (!Array.isArray(obj.flexfield_datadetail)) {
        this.$set(obj, "flexfield_datadetail", []);
        return;
      }
      obj.flexfield_datadetail.forEach((opt, idx) => {
        if (!opt) return;
        if (!opt._uid) this.$set(obj.flexfield_datadetail[idx], "_uid", this.genOptUid());
        if (opt._origLabel === undefined || opt._origLabel === null) {
          this.$set(obj.flexfield_datadetail[idx], "_origLabel", String(opt.label ?? "").trim());
        }
        if (opt._labelBlurred === undefined || opt._labelBlurred === null) {  // blur 後才顯示驗證
          this.$set(obj.flexfield_datadetail[idx], "_labelBlurred", false);
        }
      });
    },
    // Read documents
    removeReadDocument(id) {
      this.localData.read_documents = (this.localData.read_documents || []).filter(v => v !== id);
    },
    onReadDocumentsSearch(keyword) {
      this.readDocumentsSearch = keyword;
      clearTimeout(this.readDocumentsTimer);
      const ensureIds = Array.isArray(this.localData?.read_documents) ? this.localData.read_documents : [];
      this.readDocumentsTimer = setTimeout(() => {
        this.$emit("searchReadDocuments", { keyword, ensureIds });
      }, 250);
    },
    onReadDocumentsFocus() {
      if (this.readDocumentsLoading) return;
      if (this.readDocsNeedReload || (this.readDocumentsList || []).length === 0) {
        this.readDocsNeedReload = false;
        const ensureIds = Array.isArray(this.localData?.read_documents) ? this.localData.read_documents : [];
        this.$emit("searchReadDocuments", { keyword: this.readDocumentsSearch || "", ensureIds });
      }
    },
    onReadDocumentsBlur() {
      clearTimeout(this.readDocumentsTimer);
      setTimeout(() => {
        const menuActive = this.$refs.readDocsAC?.isMenuActive;
        this.readDocumentsSearch = "";
        const ensureIds = Array.isArray(this.localData?.read_documents) ? this.localData.read_documents : [];
        if (menuActive) {
          this.readDocsNeedReload = false;
          this.$emit("searchReadDocuments", { keyword: "", ensureIds });
          return;
        }
        this.readDocsNeedReload = true;
        this.$emit("resetReadDocuments");
      }, 0);
    },
    onReadDocumentsIntersect(entries, observer, isIntersecting) {
      if (!isIntersecting) return;
      if (this.readDocumentsLoading) return;
      if (!this.readDocumentsHasMore) return;
      this.$emit("loadMoreReadDocuments");
    },
    getReadDocId(item) {
      return item && typeof item === "object" ? item.id : item;
    },
    getReadDocObj(id) {
      return (this.readDocumentsList || []).find(x => x.id === id) || this.readDocumentsCache[id] || null;
    },
    readDocFileName(item) {
      const id = this.getReadDocId(item);
      const obj = this.getReadDocObj(id);
      return obj?.filename || "";
    },
    readDocChipText(item) {
      const name = this.readDocFileName(item);
      return name.length > 15 ? name.slice(0, 15) + "..." : name;
    },
    ensureCollectionOption() {
      if (String(this.resolvedDatatype) !== "Collection") return;
      if (!Array.isArray(this.localData.collection_properties_description)) {
        this.$set(this.localData, "collection_properties_description", [""]);
        this.$set(this.localData, "collection_properties", [""]);
        return;
      }
      if (!Array.isArray(this.localData.collection_properties)) {
        this.$set(this.localData, "collection_properties", []);
      }
      const descLen = this.localData.collection_properties_description.length;
      const propLen = this.localData.collection_properties.length;
      if (descLen === 0) {
        this.localData.collection_properties_description.push("");
        this.localData.collection_properties.push("");
      } else if (propLen < descLen) {
        for (let i = propLen; i < descLen; i++) {
          this.localData.collection_properties.push("");
        }
      } else if (propLen > descLen) {
        this.localData.collection_properties.splice(descLen);
      }
    },
    refreshPythonEditor() {
      this.$nextTick(() => {
        this.$refs.pythonEditor?.codemirror?.refresh();
        setTimeout(() => {
          this.$refs.pythonEditor?.codemirror?.refresh();
        }, 300);
      });
    },
    async runPythonValidation() {
      this.pythonValidating = true;
      this.pythonValidationErrors = [];
      try {
        // 從選取的 input 欄位推算執行時注入的變數名稱
        const selectedInputIds = new Set(this.localData.input || []);
        const inputVarNames = (this.userInputList || [])
          .filter(item => item.id && selectedInputIds.has(item.id))
          .map(item => this.slugifyToVariable(item.name));

        const res = await UpGPTPortalDataServices.validatePythonScript(
          this.localData.tool_config || "",
          inputVarNames,
        );
        const data = res.data;
        if (data.valid) return true;
        this.pythonValidationErrors = (data.errors || []).map(err => {
          const type = err?.type;
          if (type === "empty") {
            return this.$t("DOCUMENT_AGENT_PROPERTY.VALIDATION_EMPTY_SCRIPT");
          }
          if (type === "result_assignment") {
            return this.$t("DOCUMENT_AGENT_PROPERTY.VALIDATION_MISSING_RESULT");
          }
          if (type === "length") {
            return this.$t("DOCUMENT_AGENT_PROPERTY.VALIDATION_OVER_LIMIT", { n: this.pythonCharCount.toLocaleString() });
          }
          if (type === "syntax") {
            const raw = String(err?.message || "");
            const colonIdx = raw.indexOf("：");
            const syntaxDetail = colonIdx >= 0 ? raw.slice(colonIdx + 1).trim() : raw;
            return this.$t("DOCUMENT_AGENT_PROPERTY.VALIDATION_SYNTAX_ERROR", { line: err.line, message: syntaxDetail });
          }
          if (type === "undeclared_variable") {
            const vars = Array.isArray(err?.vars) ? err.vars.join(', ') : '';
            return this.$t("DOCUMENT_AGENT_PROPERTY.VALIDATION_UNDECLARED_VARIABLE", { vars });
          }
          return String(err?.message || "").trim();
        }).filter(Boolean);
        return false;
      } catch (e) {
        console.error("validatePythonScript failed:", e);
        this.pythonValidationErrors = [
          this.$t("DOCUMENT_AGENT_PROPERTY.VALIDATION_SERVICE_UNAVAILABLE")
        ];
        return false;
      } finally {
        this.pythonValidating = false;
      }
    },
    // 模型清單改由租戶設定供給後，只能用 id 判定圖示。原本還會比對顯示名稱
    // （name.includes('user') / includes('python')），但 display_name 現在是租戶
    // 自填的，命名成「GPT-5.4 for users」或「Gemma (python-tuned)」就會拿到錯的
    // 圖示。結果行為不變：兩個保留選項各有專屬圖示，其餘一律通用 AI 圖示。
    getModelIcon(item) {
      const id = String(item?.id || '').toLowerCase();
      if (id === workAgentModelService.MODEL_ID_USER_INPUT) return this.userInputIcon;
      if (id === workAgentModelService.MODEL_ID_PYTHON_TOOL) return this.pythonIcon;
      if (id === workAgentModelService.MODEL_ID_QRCODE) return this.qrcodeIcon;
      return this.chatGptIcon;
    },

    /**
     * 取得該租戶的模型清單並填入下拉。每次開啟對話框都會呼叫（父層的
     * columnDialog.key 每次 +1 會重建本元件），但 service 有 module-level
     * 快取，實際只有第一次會打 API。
     */
    async loadModelList() {
      this.modelListLoading = true;
      try {
        const { options, error } = await workAgentModelService.getOptions();
        this.model_list = options;
        this.modelListError = error;
      } finally {
        this.modelListLoading = false;
      }

      // 已存的模型不在清單內時（例如欄位還留著舊 key）刻意不動它：下拉會顯示
      // 空值，由必填驗證迫使使用者重選。不得自動改成預設模型後靜默儲存。
      const current = String(this.localData?.model || "").trim();
      if (this.isFileInputColumn) {
        this.ensureFileVisionModel();
      } else if (!current) {
        this.localData.model = workAgentModelService.pickDefaultModelId(this.model_list);
      }
      if (!String(this.localData.reasoning_effort || "").trim()) {
        this.localData.reasoning_effort = "minimal";
      }
    },
  },
});
</script>

<style scoped lang="css">
.knowledge-item,
.knowledge-item:hover,
.knowledge-item.v-list-item--active,
.knowledge-item:active { color: #444444 !important; }
::v-deep .column-editor-footer .v-btn.v-btn--disabled {
  background-color: #e8e8e8 !important;
  color: #ccc !important;
}
::v-deep .column-editor-footer .v-btn.v-btn--disabled .t-white { color: #ccc !important; }
.column-editor-card {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  overflow: hidden;
}
.column-editor-body {
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 16px !important;
}
::v-deep .column-editor-body.custom-scroll-area,
::v-deep .column-editor-body .v-textarea textarea {
  scrollbar-width: thin;
  scrollbar-color: rgba(153, 153, 153, 0.3) transparent;
}
::v-deep .column-editor-body .v-text-field--outlined.v-input--dense .v-input__slot { min-height: 32px !important; }
::v-deep .column-editor-body .v-text-field--outlined.v-input--dense input,
::v-deep .column-editor-body .v-textarea textarea,
::v-deep .column-editor-body .v-select__selection,
::v-deep .column-editor-body .v-select__selection--comma {
  font-size: 14px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 1.35 !important;
  color:#444;
}
::v-deep .column-editor-body .v-input { margin: 6px 0px !important; }
::v-deep .datatype-readonly .v-input__prepend-inner,
::v-deep .singleselect-opt .v-input__prepend-inner { align-self: center !important; margin-top: 0 !important; }
.type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  min-width: 0;
}
.type-icon {
  width: 20px;
  height: 20px;
  flex: 0 0 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.type-icon img {
  width: 100%; 
  height: auto;
  display: block;
}
.type-label {
  color: #444444 !important;
  font-size: 14px;
  line-height: 20px;
}
::v-deep .datatype-readonly input {
  color: #444444 !important;
  -webkit-text-fill-color: #444444 !important;
  opacity: 1 !important;
}
::v-deep .column-editor-body .user-prompt-field textarea {
  max-height: 210px;
  overflow-y: auto;
}
.python-code-hint {
  font-size: 12px;
  color: #888;
  margin-top: 2px;
  padding: 0 2px;
}
.python-editor {
  border: 1px solid rgba(0, 0, 0, 0.38);
  border-radius: 4px;
  overflow: hidden;
  margin: 6px 0;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.python-editor:focus-within {
  border-color: #518BF2;
  box-shadow: 0 0 0 1px #518BF2;
}
.python-editor ::v-deep .CodeMirror {
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  height: 210px;
  line-height: 1.5;
}
.python-editor ::v-deep .CodeMirror-sizer {
  box-sizing: content-box !important;
}
.python-char-counter {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
}
.python-char-counter--over {
  color: #f44336;
  font-weight: 500;
}
.input-var-hint {
  color: #D8D8D8;
  margin-left: 4px;
  font-size: 14px;
  font-weight: 400;
  max-width: 90px;
  flex-shrink: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.template-inline-group {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.template-upload-btn {
  height: 32px !important;
  border-color: #bdbdbd !important;
  box-shadow: none !important;
  font-size: 14px !important;
  color: #666666 !important;
}
.template-delete-inside {
  width: 24px !important;
  height: 24px !important;
  min-width: 24px !important;
  margin-top: -2px;
}
.knowledge-item-title {
  display: flex;
}
.knowledge-item-name {
  color: #444444;
  font-size: 14px;
  font-weight: 400;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.python-validation-errors {
  margin-top: 4px;
}
.python-validation-error {
  font-size: 12px;
  color: #ff5252;
  line-height: 1.6;
}
.model-list-error {
  margin-top: 4px;
  font-size: 12px;
  color: #ff5252;
  line-height: 1.6;
}
.model-option-icon {
  width: 18px;
  height: 18px;
  display: block;
  object-fit: contain;
}
</style>
